import React from 'react';

import FooterBottom from '../FooterBottom/FooterBottom';
import FooterSitemap from '../FooterSitemap/FooterSitemap';
import Container from '../interface/Container';
import { Wrapper } from './Footer.styles';

const Footer = ({ openingHours }) => (
  <Wrapper>
    <Container>
      <FooterSitemap openingHours={openingHours} />
      <FooterBottom />
    </Container>
  </Wrapper>
);

export default Footer;
